import constants from '@/common/constants';
import { getUserRegionsRfIds, getUserRoleId } from '@/common/utils/userProfile';

import { ROUTE_NAMES } from '../constants/router';

class VesRouterGuard {
  constructor(next) {
    this._role = getUserRoleId();
    this._next = next;
  }

  closeAccessForSubjectRF() {
    if (this._role === constants.USER_ROLE_ID.subjectRF) {
      const { userRegionRfIds } = getUserRegionsRfIds();
      return this._next({ name: 'RegionDashboardsVES', query: { regionId: userRegionRfIds[0] } });
    } else {
      return this._next();
    }
  }
}

export const routes = [
  //? Заказчик попросил убрать данные страницы

  // {
  //   path: '/ves/heat-map-foreign-economic-relations',
  //   name: 'HeatMapForeignEconomicRelations',
  //   component: () => import('../view/HeatMapForeignEconomicRelations.vue'),
  // },
  // {
  //   path: '/ves/implementation',
  //   name: 'Implementation',
  //   component: () => import('../view/Implementation.vue'),
  // },
  // {
  //   path: '/ves/passport-foreign-economic-relations',
  //   name: 'PassportForeignEconomicRelations',
  //   component: () => import('../view/PassportForeignEconomicRelations.vue'),
  // },
  {
    path: '/ves/projects-with-regions',
    name: 'ProjectsWithRegions',
    component: () => import('../view/ProjectsWithRegions.vue'),
  },
  {
    path: '/ves/projects-with-nations',
    name: 'ProjectsWithNations',
    component: () => import('../view/ProjectsWithNations.vue'),
  },
  {
    path: '/ves/events',
    name: 'EventsVES',
    component: () => import('../view/EventsVES.vue'),
  },
  {
    path: '/ves/events/:id',
    name: ROUTE_NAMES.events.card,
    component: () => import('../view/EventsCardVES.vue'),
  },
  {
    path: '/ves/dashboards',
    name: 'DashboardsVES',

    // TODO: Решение костыльное, т.к. минует матрицу прав. Хорошо бы убрать и сделать через нее
    beforeEnter(to, from, next) {
      const guard = new VesRouterGuard(next);

      return guard.closeAccessForSubjectRF();
    },
    component: () => import('../view/DashboardsVES.vue'),
  },
  {
    path: '/ves/region-card/:regionRfId(\\d+)?',
    name: 'RegionDashboardsVES',
    component: () => import('../view/RegionDashboardsVES.vue'),
  },
  {
    path: '/ves/country-card/:countryId(\\d+)?',
    name: 'CountryDashboardsVES',
    beforeEnter(to, from, next) {
      const guard = new VesRouterGuard(next);

      return guard.closeAccessForSubjectRF();
    },
    component: () => import('../view/CountryDashboardsVES.vue'),
  },
  {
    path: '/ves/active-agreements',
    name: 'ActiveAgreements',
    component: () => import('../view/ActiveAgreements.vue'),
  },
];
